<ul>
  @for (section of superSections(); track section.name) {
    <li>
      <a [routerLink]="['/menu-list', section.id]" [attr.data-testid]="'super-section-' + section.id">
        <span>{{ section.name }}</span>
      </a>
    </li>
  }

  @empty {
    <li>{{ 'MENU.NO_SECTIONS' | translate }}</li>
  }
</ul>